import React, { useState } from "react";

export const countries = [
  { code: "+1", name: "United States", flag: "https://flagcdn.com/w40/us.png" },
  { code: "+1", name: "Canada", flag: "https://flagcdn.com/w40/ca.png" },
  // { code: "+91", name: "India", flag: "https://flagcdn.com/w40/in.png" },
  //   {
  //     code: "+44",
  //     name: "United Kingdom",
  //     flag: "https://flagcdn.com/w40/gb.png",
  //   },
  //   { code: "+61", name: "Australia", flag: "https://flagcdn.com/w40/au.png" },
  //   { code: "+81", name: "Japan", flag: "https://flagcdn.com/w40/jp.png" },
  //   { code: "+49", name: "Germany", flag: "https://flagcdn.com/w40/de.png" },
  //   { code: "+33", name: "France", flag: "https://flagcdn.com/w40/fr.png" },
  //   { code: "+39", name: "Italy", flag: "https://flagcdn.com/w40/it.png" },
  //   { code: "+34", name: "Spain", flag: "https://flagcdn.com/w40/es.png" },
  //   { code: "+55", name: "Brazil", flag: "https://flagcdn.com/w40/br.png" },
  //   { code: "+86", name: "China", flag: "https://flagcdn.com/w40/cn.png" },
  //   { code: "+7", name: "Russia", flag: "https://flagcdn.com/w40/ru.png" },
  //   { code: "+82", name: "South Korea", flag: "https://flagcdn.com/w40/kr.png" },
  //   { code: "+27", name: "South Africa", flag: "https://flagcdn.com/w40/za.png" },
  //   { code: "+52", name: "Mexico", flag: "https://flagcdn.com/w40/mx.png" },
  //   {
  //     code: "+971",
  //     name: "United Arab Emirates",
  //     flag: "https://flagcdn.com/w40/ae.png",
  //   },
  //   { code: "+20", name: "Egypt", flag: "https://flagcdn.com/w40/eg.png" },
];

// Sort countries alphabetically
const sortedCountries = [...countries].sort((a, b) =>
  a.name.localeCompare(b.name)
);

const CountryCodeSelector = ({ onSelect }) => {
  const [selectedCountry, setSelectedCountry] = useState(countries[0]);

  const handleSelect = (event) => {
    const country = countries.find((c) => c.name === event.target.value);
    console.log(country);

    setSelectedCountry(country);
    onSelect(country);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginTop: "18px",
      }}
    >
      {/* Display Selected Flag and Code */}
      <img
        src={selectedCountry.flag}
        alt={selectedCountry.name}
        style={{ width: "50px", height: "30px", borderRadius: "3px" }}
      />
      {/* <span style={{ fontSize: "1em", fontWeight: "bold" }}>
        {selectedCountry.code}
      </span> */}

      {/* Dropdown for Country Selection */}
      <select
        onChange={handleSelect}
        value={selectedCountry.name}
        style={{
          padding: "12px",
          fontSize: "1em",
          borderRadius: "5px",
          border: "1px solid #ccc",
          cursor: "pointer",
        }}
      >
        {sortedCountries.map((country) => (
          <option key={country.name} value={country.name}>
            {country.name} ({country.code})
          </option>
        ))}
      </select>
    </div>
  );
};

export default CountryCodeSelector;
